import React from "react";
import questionsImage from "./images/flowers.webp";

function Questions() {
  return (
    <div className="bg-page">
      <section className="container text-center p-top-8 p-bottom-8">
        <div className="flex flex-justify-center m-top-4">
          <div className="col-5 col-8-xs">
            <img
              style={{ width: "100%" }}
              src={questionsImage}
              alt=""
            ></img>
          </div>
          <div className="col-12-xs col-12-sm col-8">
            <h3 className="m-bottom-2 text-primary m-top-2">
              С кого да се свържа в деня на Сватбата?
            </h3>
            <div className="text-lg p-right-10-xl p-left-10-xl text-justify">
            При възникнали въпроси от всякакво естество в деня на сватбата можете да се свържете с майката на Булката: {" "}
            </div>
            <p className="m-top-2 m-bottom-2 text-lg m-bottom-8">
              <i className="fa-solid fa-phone m-right-1"></i>Катерина: тел.{" 089 352 99 69"}
            </p>
            <h3 className="m-bottom-2 text-primary">Цветя и Подаръци</h3>
            <div className="text-lg p-right-10-xl p-left-10-xl m-bottom-8 text-justify">
              Присъствието Ви в този важен ден за нас е най - добрият подарък, който може да получим. За цветя не мислете, вместо това Ви молим - нашата благотворителна кауза подкрепете!
            </div>
            <h3 className="m-bottom-2 text-primary">Нощувка</h3>
            <div className="text-lg p-right-10-xl p-left-10-xl m-bottom-4 text-justify">
              За ваше улеснение сме резервирали места за нощувка в близост до ресторанта. Ако желаете да се възползвате от предложенията ни, моля, свържете се за съдействие с Булката:
            </div>
            <p className="m-top-2 m-bottom-2 text-lg m-bottom-8">
              <i className="fa-solid fa-phone m-right-1"></i>Инна:тел.{" 089 425 49 49"}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Questions;
